import { TimetableTimeRangeShared } from '@/model/timetable-time-range';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_TIME_FORMAT = 'HH:mm';
export const API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
export enum ConflictEventAction {
  CANCEL = 'CANCEL',
  CREATE_TIMETABLE_DATE_EXCEPTION = 'CREATE_TIMETABLE_DATE_EXCEPTION',
  CHECK_DETAILS = 'CHECK_DETAILS',
}
export const L_PITTET_APP_ID = 3;
export const L_PITTET_MANUAL_CATEGORY_ID = 10;
export const L_PITTET_AUTOMATIC_CATEGORY_ID = 11;
export const HARMONY_VENDOR_ID = 1;
export const DEFAULT_TIME_SLOT: TimetableTimeRangeShared = {
  start: null,
  end: null,
  own_category_id: null,
  possible_categories: [],
  duration: null,
  break: null,
  position: 1,
  location_id: '' as unknown as number,
};
export enum FlatPickrMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  RANGE = 'range',
}

export enum Color {
  RED = 'red',
  YELLOW = 'yellow',
  GREEN = 'green',
  BLUE_GREEN = 'blue-green',
  LIGHT_BLUE = 'light-blue',
  BLUE = 'blue',
  PURPLE = 'primary',
  PINK = 'pink',
  GRAY = 'gray',
}
export enum Language {
  FR = 'fr',
  EN = 'en',
}
